module.exports = __webpack_public_path__ + "img/QR-BG.d1dd4754.png";